import { buildParticipantEventMembershipLabel as buildEventMembershipLabelCore } from './eventParticipantUtils';
export { EVENT_PARTICIPANT_STATUSES as PARTICIPANT_STATUSES } from '../../../../utils/eventParticipation';

export const toNum = (value) => (typeof value === 'number' ? value : Number(value));

export function parsePartIds(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map(toNum).filter(Number.isFinite);
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.map(toNum).filter(Number.isFinite);
    } catch (_) {
      // JSON 以外は区切り文字で解釈
    }
    return raw
      .split(/[,\s]+/)
      .map(toNum)
      .filter(Number.isFinite);
  }
  return [];
}

export const toTimestamp = (value) => {
  if (!value) return null;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const pickFirstString = (...values) =>
  values.find((value) => typeof value === 'string' && value.trim()) || '';

export const pickFirstTrimmedString = (...values) => {
  for (const value of values) {
    if (typeof value !== 'string') continue;
    const trimmed = value.trim();
    if (trimmed) return trimmed;
  }
  return '';
};

export const parseBooleanLike = (value) =>
  value === true || value === 'true' || value === 1 || value === '1';

const buildGroupEventMaps = (events) => {
  const orderMap = new Map();
  const eventMap = new Map();
  events.forEach((event, index) => {
    const eventUuid = String(event?.event_uuid || '').trim();
    if (!eventUuid) return;
    if (!orderMap.has(eventUuid)) orderMap.set(eventUuid, index);
    if (!eventMap.has(eventUuid)) eventMap.set(eventUuid, event);
  });
  return { orderMap, eventMap };
};

export const buildParticipantEventMembershipLabel = (
  eventUuids,
  groupEvents,
  {
    artistsVisibleOnly = false,
    pickFirstStringFn = pickFirstString,
  } = {}
) => {
  const allEvents = Array.isArray(groupEvents) ? groupEvents : [];
  const targetEvents = artistsVisibleOnly
    ? (() => {
        const visibleEvents = allEvents.filter((event) =>
          parseBooleanLike(event?.members_visible_to_artists)
        );
        return visibleEvents.length > 0 ? visibleEvents : allEvents;
      })()
    : allEvents;

  const { orderMap, eventMap } = buildGroupEventMaps(targetEvents);
  return buildEventMembershipLabelCore({
    eventUuids,
    targetGroupEvents: targetEvents,
    participantGroupEventOrderMap: orderMap,
    participantGroupEventMap: eventMap,
    pickFirstString: pickFirstStringFn,
  });
};

export const joinApiAssetPath = (apiUrl, base, file) =>
  file
    ? `${apiUrl}${String(base).replace(/\/$/, '')}/${String(file).replace(/^\/+/, '')}`
    : '';

export const buildProfileProxyImageUrl = (apiUrl, base, file) => {
  const raw = joinApiAssetPath(apiUrl, base, file);
  if (!raw) return '';
  return raw.includes('?') ? `${raw}&variant=proxy` : `${raw}?variant=proxy`;
};
